/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Join_User_Has_AccountInputs */



/**
* | output |
* | --- |
* | "Already have an account?" |
*
* @param {Auth_Join_User_Has_AccountInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_join_user_has_account = /** @type {((inputs?: Auth_Join_User_Has_AccountInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Join_User_Has_AccountInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Hast du bereits ein Konto?")
	return /** @type {LocalizedString} */ ("Already have an account?")
});